import { useState } from 'react';
import get from 'lodash.get';

import Box from '../Box';
import InfoPanel from './InfoPanel';
import EditForm from './EditForm';

import useAuthentication from 'hooks/useAuthentication';

import Enums from 'utilities/enumHelper';
import FmsEnums from 'constants/componentData/fmsEnums';

const PRIMARY = FmsEnums.typeofContact.primary;

const BasicInfo = props => {
  const [edit, setEdit] = useState(false);
  const { user } = useAuthentication();
  const { profile, mappings, update } = props;
  const { basicInfo: info } = profile || {};

  const getProfile = path => get(profile, path, []) || [];
  const typePrimary = item => item.typeofContact === PRIMARY;

  const gender = Enums.valueToOptionLabel(mappings.gender, info.gender);
  const ethnicity = Enums.valueToOptionLabel(
    mappings.ethnicity,
    info.ethnicity,
  );
  const phone = getProfile('phoneNumbers').find(typePrimary) || {};
  const email = get(profile, 'emailAddresses[0].emailAddress', user.email);

  const onEdit = () => setEdit(true);

  return (
    <Box title="Basic Profile" onEdit={!edit && onEdit}>
      {edit ? (
        <EditForm
          info={info}
          email={email}
          phone={phone}
          mappings={mappings}
          onCancel={() => setEdit(false)}
          onSave={update}
        />
      ) : (
        <InfoPanel
          info={info}
          gender={gender}
          ethnicity={ethnicity}
          email={email}
          phone={phone}
        />
      )}
    </Box>
  );
};

export default BasicInfo;
